import { getCampaigns } from '../../api';
import { useListFetch } from '../../hooks';
import type { GetCampaignsFilters, CampaignType } from '../../api';

export const useCampaigns = () => {
  return useListFetch<CampaignType, GetCampaignsFilters>(
    async params => {
      const result = await getCampaigns(
        params?.filters || {},
        params.pagination
      );

      return { content: result };
    },
    { initialFilters: { status: '' }, withQueryParams: true }
  );
};
